<template>
  <div class="planDetailPage">
    <StickyTop />
    <Banner zoomWay="click" :slideList="slideList" :dblclickImage="dblclickImage" />
    <div class="planInfoList">
      <h3 class="planName">{{ detailData?.productName }}</h3>
      <p v-if="detailData.ctag" class="planTag" style="margin-bottom:5px;">{{ detailData?.ctag }}</p>
      <span class="moneyWeight">{{ shopPrice }}</span>
    </div>
    <!-- devTemp -->
    <!-- <div>selectShopVariantItem: {{ selectShopVariantItem }}</div>
    <div>currentSkuLis: {{ currentSkuLis.length }}</div>
    <div>allSkuLis: {{ allSkuLis.length }}</div>
    <div>applyDealerParam: {{ applyDealerParam }}</div> -->
    <!-- <div>skuAloneData{{ skuAloneData }}</div> -->
    <div class="dealerInfoList">
      <van-row class="label">
        <van-col span="8">车辆：</van-col>
        <van-col span="16">{{ carInfoTxts }}</van-col>
      </van-row>
      <van-row class="label" v-show="salesAttributesTxt !== false">
        <van-col span="8">选择：</van-col>
        <van-col span="16" @click="selectSalesAttributes"
          ><span class="fvlr salesAttribute">
            <span>{{ salesAttributesTxt }}</span>
            <van-icon name="arrow" /> </span
        ></van-col>
      </van-row>
      <CurrentDealer @setLoading="setLoading" from="shopDetail" :isOtrOrderNo="isOtrOrderNo" :colLabelSpan="8">
        <template #colLabel><span>销售经销商：</span></template>
        <template #noDealer>请选择经销商查看商品详情及价格</template>
      </CurrentDealer>
      <UseDealer ref="useDealerRef" @setLoading="setLoading" :isShowPhone="true" :colLabelSpan="8" :param="applyDealerParam" @useclick="handleUseclick">
        <template #colLabel><span>使用/服务范围:</span></template>
        <template #currentDealerBox>
          <span v-if="hasDealer" class="accordionContent underline themeColor">点击查看</span>
          <span v-else class="useDealerRmark">请选择商品及购买经销商后查看</span>
        </template>
        <template #afterName><span></span></template>
      </UseDealer>
    </div>
    <SkuImg :datas="skuAloneData" />
    <div class="temp"></div>
    <!-- 底部按钮栏目 -->
    <!-- <GoodsBar :isEnterShoppingCar="isEnterShoppingCar" :isEnable="isEnable" @toShoppingCar="toShoppingCar" /> -->
    <GoodsBar :isEnterShoppingCar="isEnterShoppingCar && !isOtrOrderNo" :isEnable="isEnable" from="shopDetail" @clickGoodBtn="clickGoodBtn">
      <ConfirmShop
        ref="confirmShopRef"
        @clickSureBtn="clickSureBtn"
        :datas="{ shopInfoDatas, carInfoTxt, useCarInfo }"
        :showTyreNum="showShopNum"
        :from="confirmTyreFrom"
        :type="confirmTyreType"
      />
    </GoodsBar>
    <div v-show="isShowLoad" class="loadBox">
      <van-loading size="30px" vertical color="#fff"><span style="color:#fff">加载中...</span> </van-loading>
    </div>
    <ShowDiffCarInfo ref="refShowDiffCarInfo" />
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch, watchEffect, onUnmounted, computed, ref, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ImagePreview, Dialog } from 'vant'
import Banner from '@/components/common/Banner'
import GoodsBar from '@/components/common/GoodsBar'
import CurrentDealer from '@/components/dealer/CurrentDealer'
import ConfirmShop from '@/components/shop/ConfirmShop'
import StickyTop from '@/components/shop/StickyTop.vue'
import SkuImg from '@/components/shop/SkuImg.vue'
import UseDealer from '@/components/canUseDealer/CurrentDealer'
import { getDealers } from '@/api/plan'
import { showToast } from '@/util/couponCollection'
import { backTop } from '@/util'
import { couponList } from '@/util/plan'
import { addEightHour, getDistance } from '@/util'
import { useStore } from 'vuex'
import useCurrentCarInfo from '@/hooks/directSales/useCurrentCarInfo'
import useShopDetail from '@/hooks/directSales/useShopDetail'
import { addShoppingCar } from '@/api/shoppingCar'
import { getShopInfoByqrInfoKey, getCdoQrCodeInfoByqrInfoKey } from '@/api/directSales'
import ShowDiffCarInfo from '@/views/customer/car/ShowDiffCarInfo.vue'

export default {
  name: 'shopDetail',
  components: {
    Banner,
    CurrentDealer,
    UseDealer,
    GoodsBar,
    ConfirmShop,
    StickyTop,
    SkuImg,
    ShowDiffCarInfo
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const refShowDiffCarInfo = ref(null)
    const useDealerRef = ref()
    const confirmShopRef = ref()
    const { carInfoTxt, carInfo: useCarInfo } = useCurrentCarInfo()
    const {
      getShopDetailFn,
      salesAttributesTxt,
      slideList,
      dblclickImage,
      detailData,
      currentSkuLis,
      allSkuLis,
      isEnterShoppingCar,
      isEnable,
      hasDealer,
      shopInfoDatas,
      applyDealerParam,
      selectShopVariantItem,
      shopPrice
    } = useShopDetail()
    let qrCarInfo = {}
    let { spuId, from, gsCode, orderNo, skuId, fin, boUserId = '', carInfo, salesChannel = '', qrKey = '', codeTypeFlag = '' } = route.query
    // devTemp 1544943929577033729  1555032936493907969
    // spuId = '1555032936493907969' from=scan&salesChannel=OTRQR
    store.commit('SETSkUITEM', {})
    store.commit('SETSTEPPEROPTION', {})
    const state = reactive({
      carInfoTxts: '',
      isOtrOrderNo: orderNo,
      gsCode: gsCode,
      qrData: null,
      confirmTyreFrom: '', //详情页/购物车/属性选择
      confirmTyreType: '', //立即购买/加入购物车
      showShopNum: 0,
      max: 0,
      isShowLoad: false,
      dealer: '',
      dealerJoinPlanFlag: ['loyaltyList', 'shoppingCarList', 'scan'].includes(from)
    })
    // 详情--》salesAttributes，SkuList
    // 经销商---》 SkuList
    // watchEffect(async () => {
    //   let { gsCode } = store.state.loyaltyDealerInfo
    //   let spuId = store.state.spuId
    //   if (gsCode && spuId) {
    //     try {
    //       state.currentSkuLis = await getShopSkuListByGsCode({ gsCode, spuId })
    //     } catch (error) {
    //       state.currentSkuLis = []
    //     }
    //   } else {
    //     state.currentSkuLis = []
    //   }
    // })

    // store.dispatch('setDealerJoinPlanFlag', '')
    // 设置gsCode，防止加载默认经销商
    gsCode && store.dispatch('setDealerInfo', { gs_code: gsCode, gsCode })
    const initByfrom = async data => {
      const isScan = from === 'scan' || from === 'QRcode'
      // isSperate 是否运营
      let _gsCode = data.gsCode || gsCode
      const isFreeze = isScan && _gsCode
      store.commit('SETDEALERfREEZEFLAG', isFreeze)
      if (carInfo) {
        //有车辆信息-就需要插入车辆信息
        refShowDiffCarInfo.value?.createCarInfo(carInfo)
        store.commit('SETBOUSERINFO', {
          id: boUserId
        })
      }
      if (isFreeze) {
        await getDealerFn({ gsCode: _gsCode })
      }
    }
    const handleUseclick = () => {
      if (!applyDealerParam || !applyDealerParam?.value?.skuId || !applyDealerParam?.value?.gsCode) {
        showToast('请先选择销售经销商和商品')
        return
      }
      useDealerRef.value.showPop()
    }
    const getDealerFn = async (data = {}) => {
      try {
        let { lat, lng } = store.state.position
        let { list = [] } = await getDealers({
          gsCode: data?.gsCode || '',
          latitude: lat,
          longitude: lng,
          productType: 'sc'
        })
        const dealerInfo = list[0] || {}
        dealerInfo.distance = getDistance(dealerInfo.distance)
        let _gsCode = dealerInfo.gs_code || dealerInfo.gsCode || state.gsCode
        dealerInfo.gs_code = dealerInfo.gsCode = _gsCode
        store.dispatch('setLoyaltyDealerInfo', dealerInfo)
      } catch (e) {
        showToast(e.message, '获取经销商详情失败')
        store.dispatch('setLoyaltyDealerInfo', {})
      }
    }
    onUnmounted(() => {
      store.commit('SETDEALERfREEZEFLAG', false)
      store.commit('SETSPUID', '')
    })
    const setLoading = data => {
      state.isShowLoad = data
    }

    const showImg = index => {
      ImagePreview({
        images: dblclickImage,
        startPosition: index
      })
    }
    const toShoppingCar = () => {
      router.push({ path: '/shoppingCar', query: { event: '查看购物车' } })
    }
    const clickSureBtn = data => {
      console.log('clickSureBtn----', data)
      // clickGoodBtn(data)
      if (data.type == 'bugNow' && data.from === 'shopDetail') {
        toCreateOrder()
      }
      if (data.type == 'addShoppingCar' && data.from === 'shopDetail') {
        addShoppingCarFn()
      }
      if (data.type == 'selectAttribut' && data.from === 'shopDetail') {
        // 目前不操作数据
      }
    }
    // // 去购买下单页面
    const toCreateOrder = () => {
      let loyaltyDealerInfo = store.state.loyaltyDealerInfo || {}
      let gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
      let skuId = store.state?.skuItem?.skuId
      if (!gsCode) {
        showToast('请选择经销商')
        return
      }
      if (!skuId) {
        // devTemp
        showToast('请选择商品')
        return
      }
      let currentBuyProductInfo = [{ ...shopInfoDatas.value, orderNo: state.isOtrOrderNo, count: store.state.stepperOption?.value }]
      let shopData = {
        //  productAmount: item.num, //数量
        //   productId: item._data?.productId, //产品id
        //   productType: item._data?.productType, //5服务合约6礼包
        //   gsCode: item.gsCode, //gscode
        //   customerCarId: item._data?.customerCarId //车辆id
        productAmount: store.state.stepperOption?.value,
        productId: skuId,
        productType: 5,
        gsCode: gsCode,
        orderNo: state.isOtrOrderNo,
        customerCarId: useCarInfo.value?.id,
        salesAttributesTxt: salesAttributesTxt.value,
        _data: detailData.value
      }
      currentBuyProductInfo = { shopData, qrData: state.qrData }
      let path = '/confirmDirectSalesOrder'
      let query = { from: 'shopDetail', event: '商城商品下单' }
      store.dispatch('setCurrentBuyProductInfo', currentBuyProductInfo)
      path && router.push({ path, query })
    }
    //加入购物车
    const addShoppingCarFn = async () => {
      let loyaltyDealerInfo = store.state.loyaltyDealerInfo || {}
      let gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
      let skuId = store.state?.skuItem?.skuId
      if (!gsCode) {
        showToast('请选择经销商')
        return
      }
      if (!skuId) {
        showToast('请选择商品')
        return
      }
      let params = {
        customerCarId: useCarInfo.value?.id, //车辆编号
        delStatusFlag: 0, //删除状态
        gsCode: gsCode, //经销商code
        productId: skuId, //商品编号
        productQuantity: store.state.stepperOption?.value, //购买商品数量
        productType: 3 //购买商品类型{1:计划2:轮胎,3:服务合约}
      }
      console.log('addShoppingCarFn----', params)
      try {
        const { productId } = await addShoppingCar(params)
        if (productId) {
          showToast('加入购物车成功')
          confirmShopRef.value?.closePop()
        }
        store.dispatch('getCountOfShoppingCar')
      } catch (e) {
        showToast(e.message, '加入购物车失败')
      }
    }
    const selectSalesAttributes = () => {
      // console.log('salesAttributesTxt !== false', salesAttributesTxt.value, detailData.value)
      if (detailData.value?.uploadSkuCount === 1 && detailData.value?.skuList?.length === 1) {
        return
      }
      clickGoodBtn({ type: 'selectAttribut', from: 'shopDetail' })
    }
    const clickGoodBtn = data => {
      let { loyaltyDealerInfo } = store.state
      let gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
      let skuId = store.state?.skuItem?.skuId
      if (!gsCode) {
        showToast('请先选择一个销售经销商')
        return
      }
      if (detailData.uploadSkuCount === 1 && detailData.value?.skuList?.length === 1) {
        // 直接去结算页面

        if (!skuId) {
          showToast('请选择商品')
          return
        }
        if (data.type == 'bugNow') {
          toCreateOrder()
        }
        if (data.type == 'addShoppingCar') {
          addShoppingCarFn()
        }
        return
      }
      if (['selectAttribut', 'bugNow', 'addShoppingCar'].includes(data.type)) {
        state.confirmTyreFrom = data.from
        state.confirmTyreType = data.type
        nextTick(() => {
          state.showShopNum += 1
        })
      }
      if (data.type == 'toShoppingCar') {
        router.push({ path: '/shoppingCar', query: { event: '查看购物车' } })
      }
      // // 立即购买
      // data.type == 'bugNow' && toCreateOrder()
      // // 加入购物车
      // data.type == 'addShoppingCar' && addShoppingCar()
    }

    const skuImgData = computed(() => {
      return detailData.value?.detailPics
    })
    watch(
      [() => store.state.position, () => state.qrData],
      async ([position, qrData]) => {
        console.log('shopDetail-watch-', position, qrData)
        position &&
          position?.lat &&
          setTimeout(() => {
            let { loyaltyDealerInfo: dealerInfo } = store.state
            let dealerGsCode = dealerInfo?.gs_code || dealerInfo?.gsCode
            let qrGsCode = qrData?.gsCode
            let _gsCode = gsCode || qrGsCode || dealerGsCode
            console.log('shopDetail-watch-', _gsCode)
            if (_gsCode) {
              if (!dealerInfo.distance) {
                //有gscode and 没有距离 => 刷新距离
                getDealerFn({ gsCode: _gsCode })
              }
            } else {
              // 没有经销商 and 有经纬度 => 尝试再次获取距离最近的经销商
              getDealerFn()
            }
          }, 500)
      },
      { deep: true }
    )
    const skuAloneData = computed(() => {
      let skuItem = store.state.skuItem || {}
      let detailPics = detailData.value?.detailPics || []
      let skuPics = (skuItem.detailPics?.length && skuItem.detailPics) || detailPics
      return { ...skuItem, skuPics }
    })

    onMounted(async () => {
      let { loyaltyDealerInfo } = store.state
      console.log('shopDetail-onMounted-', orderNo, loyaltyDealerInfo)
      let gsCode = orderNo ? state.gsCode : loyaltyDealerInfo?.gsCode || loyaltyDealerInfo?.gs_code
      let fins = orderNo ? fin : useCarInfo.value?.fin
      let qrData = {}
      if (salesChannel && qrKey) {
        try {
          if (codeTypeFlag == 2) {
            //cdoOTR扫码
            qrData = await getCdoQrCodeInfoByqrInfoKey({ qrInfoKey: qrKey })
          } else {
            qrData = await getShopInfoByqrInfoKey({ qrInfoKey: qrKey })
          }
          const {
            productId,
            baumuster = '',
            customerCarId: id = '',
            fin = '',
            vin = '',
            plate = '',
            model = '',
            threeGuaranteesDate = '',
            productAmount,
            firstRegistrationDate = ''
          } = qrData
          state.qrData = { ...qrData, codeTypeFlag: 2 }
          qrCarInfo = { fin, vin, plate, model, baumuster, threeGuaranteesDate, firstRegistrationDate, isDefault: true }
          carInfo = JSON.stringify(qrCarInfo)
          qrCarInfo.id = id
          store.dispatch('setCurrentCarInfo', qrCarInfo)
          store.commit('SETSkUITEM', { skuId: productId })
          store.commit('SETSTEPPEROPTION', {
            ...store.state.stepperOption,
            value: productAmount
          })
        } catch (e) {
          // showToast(e.message, '获取二维码信息失败')
          showToast(e.message, {
            defaultMsg: '获取二维码信息失败',
            type: 'fail',
            duration: 4000,
            position: 'middle',
            overlay: true,
            onOpened: () => {
              router.replace({ path: '/' })
            },
            onClose: () => {
              // router.replace({ path: '/' })
            }
          })
          return false
        } finally {
          console.log('getShopInfoByqrInfoKey--finally')
        }
      }
      let _spuId = qrData?.spuId || spuId
      let _gsCode = orderNo ? gsCode : qrData?.gsCode || gsCode
      let _fin = qrData?.fin || fins
      let _skuId = qrData?.productId || skuId
      await initByfrom({ gsCode: _gsCode })
      await getShopDetailFn({ spuId: _spuId, orderNo: state.isOtrOrderNo, gsCode: _gsCode, fin: _fin, salesChannel, _skuId }, { carInfo: qrCarInfo })
      nextTick(() => {
        if (state.isOtrOrderNo && shopInfoDatas?.value?.carInfo) {
          store.dispatch('setCurrentCarInfo', shopInfoDatas?.value?.carInfo)
          let currentCarInfo = shopInfoDatas?.value?.carInfo
          let plate = currentCarInfo && currentCarInfo.plate ? currentCarInfo.plate : ''
          let model = currentCarInfo && currentCarInfo.model ? currentCarInfo.model.replace(/\(.*?\)/g, '') : ''
          state.carInfoTxts = model ? `${plate || '暂无车牌'} | ${model}` : ''
          console.log('shopDetail-onMounted--state.carInfoTxts', state.carInfoTxts)
        } else {
          state.carInfoTxts = carInfoTxt
        }
      })
      backTop()
    })
    return {
      ...toRefs(state),
      skuAloneData,
      salesAttributesTxt,
      selectShopVariantItem,
      skuImgData,
      shopInfoDatas,
      showImg,
      getShopDetailFn,
      toShoppingCar,
      setLoading,
      refShowDiffCarInfo,
      handleUseclick,
      carInfoTxt,
      useCarInfo,
      clickGoodBtn,
      slideList,
      dblclickImage,
      detailData,
      currentSkuLis,
      allSkuLis,
      isEnterShoppingCar,
      isEnable,
      hasDealer,
      applyDealerParam,
      selectSalesAttributes,
      useDealerRef,
      confirmShopRef,
      clickSureBtn,
      shopPrice
    }
  }
}
</script>

<style lang="scss" scoped>
.planDetailPage {
  background-color: #f5f5f5;
  text-align: left;
  padding-bottom: calc(100px + constant(safe-area-inset-bottom));
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  .mySwipe {
    margin-bottom: 18px;
    img {
      width: 100%;
      height: 210px;
    }
  }
  .planInfoList {
    padding: 12px 20px;
    background-color: #fff;
    margin-bottom: 8px;
  }
  .dealerInfoList {
    padding: 18px 20px 10px;
    background-color: #fff;
  }
}
.planDetailPage::-webkit-scrollbar {
  display: none;
}
// 计划信息样式
.planInfoList {
  h3 {
    font-size: 18px;
    color: #333;
    font-weight: 700;
    margin-bottom: 12px;
  }
  .moneyWeenyRow {
    margin-bottom: 10px;
  }
  .moneyWeeny {
    font-size: 12px;
    color: #666;
  }
  .moneyWeight {
    font-size: 16px;
    color: #3088c5;
    font-weight: bold;
    line-height: 30px;
  }
}
.temp {
  height: 0;
  padding-bottom: calc(100px + constant(safe-area-inset-bottom));
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
}

// 经销商样式
.dealerInfoList {
  .label {
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    line-height: 18px;
  }

  .van-divider {
    margin: 8px 0;
  }
}

.colLabel,
.colValue {
  font-size: 14px;
  color: #333;
  line-height: 30px;
  vertical-align: middle;
}
.useDealerRmark {
  color: #999;
  font-size: 14px;
}
.accordionContent {
  width: 100%;
  :deep(p) {
    word-break: break-all;
  }
}
.loadBox {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  padding-top: 250px;
  background-color: rgba($color: #000000, $alpha: 0.4);
}
.salesAttribute {
  border-bottom: 1px solid #ccc;
  font-style: oblique;
}
</style>
